import { client } from '@/modules/HttpClient';
import type * as I from '@/interface/recommend';

/**
 * 根据key获取推荐位信息
 * @param keys
 * @returns
 */
export async function getRecommendationsByKey(
    args: I.IGetRecommendationsArgs,
): Promise<Record<string, I.IRecommendData>> {
    const keys = args.keys;
    if (!keys || keys.length === 0) return {};
    const position = Array.isArray(keys) ? keys.join(',') : keys;

    const result = await client.get<Record<string, I.IRecommendData>>(
        `/ad/recommendations/batch?no-mobile-redirection=1&keys=${position}&viaReoAPI=true&lang=${args.lang}`,
    );
    return result;
}
